import { type Node } from '@xyflow/react';

import {
  type AppNode,
  type CanvasModeType,
  type ImageData,
  type ImageTransformMode,
  type TextData,
  type VideoData,
  type VideoTransformMode,
} from '../types';

const VIDEO_TRANSFORM_MODES = new Set<string>(['videoConvert'] satisfies VideoTransformMode[]);

export function isVideoTransformMode(mode: CanvasModeType): mode is VideoTransformMode {
  return VIDEO_TRANSFORM_MODES.has(mode);
}

export function isImageTransformMode(mode: CanvasModeType): mode is ImageTransformMode {
  return mode !== 'default' && !isVideoTransformMode(mode);
}

export type ImageNode = Node<ImageData, 'image'>;

export function isImageNode(obj: AppNode | undefined): obj is ImageNode {
  return obj?.type === 'image';
}

export type TextNode = Node<TextData, 'text'>;

export function isTextNode(obj: AppNode | undefined): obj is TextNode {
  return obj?.type === 'text';
}

export type VideoNode = Node<VideoData, 'video'>;

export function isVideoNode(obj: AppNode | undefined): obj is VideoNode {
  return obj?.type === 'video';
}
